// extracted by mini-css-extract-plugin
module.exports = {"pipeline-job-stage-header":"styles-module__pipeline-job-stage-header___2wMDX"};